const isMobile = window.innerWidth <= 768; // Change the breakpoint value as needed
const selectorPrefix = isMobile ? '.collection-drawer__inner' : '';

const filterCheckboxes = document.querySelectorAll(`${selectorPrefix} .collection__filter-checkbox-list .checkbox`);
function updateFilterCheckboxes(availableTags, activeFilterGroupIndices) {
    document.querySelectorAll(`${selectorPrefix} .collection__filter-group`).forEach((filterGroup, index) => {
        let availableCount = 0;
        if (!activeFilterGroupIndices.includes(index)) {
            filterGroup.querySelectorAll(`${selectorPrefix} .collection__filter-checkbox`).forEach((li) => {
                const checkbox = li.querySelector('.checkbox');
                const tag = checkbox.dataset.tag;



                if (availableTags.includes(tag)) {
                    li.classList.add('is_available');
                    li.classList.remove('not_available');
                    availableCount++;
                } else {
                    if (!checkbox.checked) {
                        li.classList.add('not_available');
                    }
                    li.classList.remove('is_available');
                }
            });


            if (availableCount === 0) {
                filterGroup.classList.add('not_available');
            } else {
                filterGroup.classList.remove('not_available');
            }
        }
    });
}
function updateFilterStates() {
    const currentUrl = window.location.href;
    const fetchUrl = `${currentUrl}?view=json`;

    fetch(fetchUrl)
        .then((response) => response.json())
        .then((data) => {
            const availableTags = data.result.split(',').map(tag => tag.toLowerCase().replace(/\s+/g, '-'));

            // Find the active filter group indices.
            const activeFilterGroupIndices = Array.from(filterCheckboxes)
                .filter((checkbox) => checkbox.checked)
                .map((checkbox) => Array.from(document.querySelectorAll(`${selectorPrefix} .collection__filter-group`)).indexOf(checkbox.closest(`${selectorPrefix} .collection__filter-group`)));

            // If Group #1 value changed, click buttons for other active checkboxes and update classes.
            if (activeFilterGroupIndices.includes(0) && activeFilterGroupIndices.length === 1) {
                document.querySelectorAll(`${selectorPrefix} .collection__filter-group:not(:first-child) .collection__filter-checkbox .checkbox:checked`).forEach((checkbox) => {

                });
                updateFilterCheckboxes(availableTags, [0]);
            } else {
                updateFilterCheckboxes(availableTags, activeFilterGroupIndices.concat(0));
            }
        })
        .catch((error) => {
            console.error('Error fetching available tags:', error);
        });
}

document.addEventListener('DOMContentLoaded', updateFilterStates);
document.addEventListener('theme:loading:end', updateFilterStates);
